import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxHeight: "80vh",
  },
  headContainer: {
    backgroundColor: "#FFFFFF",
    minWidth: "40rem",
  },
  main: {
    borderRadius: "4px",
  },
  inputRoot: {
    margin: "1rem",
  },
  inputInput: {
    borderRadius: "4px",
    backgroundColor: "white",
    border: "solid white 1px",
    "&:hover": {
      border: "solid lightgray 1px",
    },
    transition: theme.transitions.create("width"),
    width: "34.5rem",
    padding: "0.5rem",
  },
  matchingRequestContainer: {
    borderRadius: "4px",
  },
  searchIcon: {
    color: "white",
  },
  loader: {
    minHeight: "19rem",
    display: "flex",
    alignItems: "center",
  },
  formControl: {
    minWidth: "100%",
  },
  sensorListContainer: {
    margin: "1rem",
    marginTop: "0",
    padding: "1rem",
    paddingTop: "0",
    maxHeight: "50vh",
    overflowY: "scroll",
  },
  stockpileListContainer: {
    marginLeft: "1rem",
    marginRight: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    maxHeight: "5vh",
    overflowY: "scroll",
    fontSize: "14px",
    color: "#000000",
  },
  sensorListTable: {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: "6px",
  },
  sensorListTableCell: {
    border: 0,
  },
  sensorListTableCheckBox: {
    border: 0,
    textAlign: "right",
  },
  exportModalHeader: {
    minHeight: "52px",
    margin: "1rem",
    padding: "1rem",
    fontWeight: "bold",
    fontSize: "18px",
  },
  listHeader: {
    paddingLeft: "2rem",
    paddingRight: "2rem",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
  },
  listBody: {
    paddingLeft: "2rem",
    paddingRight: "2rem",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.6)",
    paddingTop: "1rem",
  },
  exportModalFooter: {
    minHeight: "52px",
    paddingLeft: "2rem",
    paddingRight: "2rem",
  },
  formControlLabelSize: {
    fontSize: "12px",
  },
  formControlLeftMargin: {
    marginLeft: "2rem",
  },
}));

export default useStyles;
